<template>
    <app-layout>
        <Head>
            <title>Aufträge</title>
        </Head>

        <template v-slot:overline>
            <translate>Meine Aufträge</translate>
        </template>

        <template v-slot:headline><translate>Über die Suche in der Tabelle können Sie die Daten filtern.</translate></template>

        <div class="producer-orders">
            <div class="row">
                <div class="col">
                    <dashboard-new-orders :new-orders="newOrders" />
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <dashboard-running-orders :running-orders="runningOrders"/>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <dashboard-completed-orders :completed-orders="completedOrders"/>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@partfactory/Layouts/AppLayout';
import DashboardNewOrders from '@partfactory/Pages/Producer/Dashboard/DashboardNewOrders';
import DashboardRunningOrders from '@partfactory/Pages/Producer/Dashboard/DashboardRunningOrders';
import DashboardCompletedOrders from '@partfactory/Pages/Producer/Dashboard/DashboardCompletedOrders';
export default {
    name: 'Offers',
    components: {
        DashboardCompletedOrders,
        DashboardRunningOrders,
        DashboardNewOrders, AppLayout},
    props: {
        newOrders: Object,
        runningOrders: Object,
        completedOrders: Object,
    },
};
</script>
